import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vShow as _vShow, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_4 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-10"
}
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "",
  title: "Sigla"
}, "Sigla", -1)
const _hoisted_7 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_8 = {
  key: 0,
  class: "ant-input-group-addon"
}
const _hoisted_9 = {
  key: 1,
  class: "ant-col ant-col-xs-24 ant-col-xl-8"
}
const _hoisted_10 = {
  key: 2,
  class: "ant-col ant-col-xs-24 ant-col-xl-8"
}
const _hoisted_11 = { class: "ant-row" }
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_15 = { class: "ant-row" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_17 = { class: "ant-row" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  class: "",
  title: "Estoque negativo"
}, "Estoque negativo", -1)
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  class: "",
  title: "Permite ajustar estoque"
}, "Permite ajustar estoque", -1)
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_24 = { class: "ant-row" }
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_26 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-2",
  style: {"padding-top":"12px"}
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-grade-personalizada-titulo" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-11 ant-col-xl-20" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Pessoa")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-6 ant-col-xl-1" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "S")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-6 ant-col-xl-1" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "E")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-1 ant-col-xl-1" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" })
  ])
], -1)
const _hoisted_30 = { class: "ant-col ant-col-xs-11 ant-col-xl-20" }
const _hoisted_31 = { class: "ss-margin-campos" }
const _hoisted_32 = { class: "ant-col ant-col-xs-6 ant-col-xl-1" }
const _hoisted_33 = { class: "ant-col ant-col-xs-6 ant-col-xl-1" }
const _hoisted_34 = { class: "ant-col ant-col-xs-2 ant-col-xl-2" }
const _hoisted_35 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_tipo_estoque = _resolveComponent("selecionar-tipo-estoque")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_estoque = _resolveComponent("selecionar-estoque")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_selecionar_centro_custo = _resolveComponent("selecionar-centro-custo")!
  const _component_selecionar_sim_nao = _resolveComponent("selecionar-sim-nao")!
  const _component_selecionar_empresa = _resolveComponent("selecionar-empresa")!
  const _component_card = _resolveComponent("card")!
  const _component_selecionar_tipo_produto = _resolveComponent("selecionar-tipo-produto")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_selecionar_pessoa = _resolveComponent("selecionar-pessoa")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      centered: "",
      keyboard: false,
      width: 900,
      visible: _ctx.modalBase.computedVisivel,
      "onUpdate:visible": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
      "wrap-class-name": "ss-modal-cadastros"
    }, {
      title: _withCtx(() => [
        _createTextVNode(" Cadastro de Estoque "),
        _createVNode(_component_a_switch, {
          checked: _ctx.state.estoque.ativo,
          "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.estoque.ativo) = $event)),
          style: {"float":"right"},
          "checked-children": "Ativo",
          "un-checked-children": "Inativo"
        }, null, 8, ["checked"])
      ]),
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          ((_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Incluir && _ctx.telaBase.permissaoDados.incluir)
              || (_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Visualizar && _ctx.telaBase.permissaoDados.alterar))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("button", {
                  type: "button",
                  class: "ant-btn ant-btn-lg ant-btn-secondary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.salvar(true)))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvarNovo), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.salvar(false)))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvar), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.telaBase.carregando
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, { layout: "vertical" }, {
              default: _withCtx(() => [
                _createVNode(_component_card, { titulo: "DADOS PRINCIPAIS" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_a_form_item, {
                          label: "Tipo",
                          class: "ss-margin-campos",
                          rules: [{ required: true }]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_tipo_estoque, {
                              codigoSelecionado: _ctx.state.estoque.tipo,
                              "onUpdate:codigoSelecionado": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.estoque.tipo) = $event))
                            }, null, 8, ["codigoSelecionado"])
                          ]),
                          _: 1
                        })
                      ]),
                      (_ctx.state.estoque.tipo === _ctx.ETipoEstoque.Sintetico || _ctx.state.estoque.tipo === _ctx.ETipoEstoque.Analitico)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createVNode(_component_a_form_item, {
                              label: "Estoque Pai",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_estoque, {
                                  codigoSelecionado: _ctx.state.estoque.codigoEstoquePai,
                                  "onUpdate:codigoSelecionado": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.estoque.codigoEstoquePai) = $event)),
                                  ignorarEstoques: [_ctx.state.estoque.codigo],
                                  apenasTipoSintetico: true,
                                  empresas: _ctx.telaBase.empresasSelecionadas,
                                  onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.obterEstruturaOrganizacional(_ctx.state.estoque.codigoEstoquePai)))
                                }, null, 8, ["codigoSelecionado", "ignorarEstoques", "empresas"])
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_a_form_item, {
                          class: "ss-margin-campos",
                          rules: [{ required: true }]
                        }, {
                          label: _withCtx(() => [
                            _hoisted_6,
                            _createVNode(_component_a_tooltip, {
                              placement: "top",
                              title: "A sigla do estoque é utilizada para identificar e compor a estrutura organizacional dos estoques."
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_icone, {
                                  class: "ss-icone-informacao-campo",
                                  nome: "informacao-campo"
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_7, [
                              (_ctx.state.estoque.estruturaOrganizacional)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.state.estoque.estruturaOrganizacional) + ".", 1))
                                : _createCommentVNode("", true),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                maxlength: "250",
                                class: "ant-input",
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.estoque.sigla) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.state.estoque.sigla]
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      (_ctx.state.estoque.tipo === _ctx.ETipoEstoque.Sintetico || _ctx.state.estoque.tipo === _ctx.ETipoEstoque.Analitico)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createVNode(_component_a_form_item, {
                              label: "Centro de Custo Padrão",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_centro_custo, {
                                  codigoSelecionado: _ctx.state.estoque.codigoCentroCustoPadrao,
                                  "onUpdate:codigoSelecionado": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.estoque.codigoCentroCustoPadrao) = $event)),
                                  empresas: _ctx.telaBase.empresasSelecionadas
                                }, null, 8, ["codigoSelecionado", "empresas"])
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: _normalizeClass(_ctx.state.estoque.tipo === _ctx.ETipoEstoque.Padrao ? 'ant-col ant-col-xs-24 ant-col-xl-10' : 'ant-col ant-col-xs-24 ant-col-xl-24')
                      }, [
                        _createVNode(_component_a_form_item, {
                          label: "Descrição",
                          class: "ss-margin-campos",
                          rules: [{ required: true }]
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              maxlength: "250",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.estoque.descricao) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.estoque.descricao]
                            ])
                          ]),
                          _: 1
                        })
                      ], 2),
                      (_ctx.state.estoque.tipo === _ctx.ETipoEstoque.Padrao)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createVNode(_component_a_form_item, {
                              label: "Centro de Custo Padrão",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_centro_custo, {
                                  codigoSelecionado: _ctx.state.estoque.codigoCentroCustoPadrao,
                                  "onUpdate:codigoSelecionado": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.estoque.codigoCentroCustoPadrao) = $event)),
                                  empresas: _ctx.telaBase.empresasSelecionadas
                                }, null, 8, ["codigoSelecionado", "empresas"])
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_a_form_item, {
                          label: "Padrão Frente Caixa",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_sim_nao, {
                              radioButton: true,
                              valor: _ctx.state.estoque.padraoFrenteCaixa,
                              "onUpdate:valor": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.estoque.padraoFrenteCaixa) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_a_form_item, {
                          label: "Empresas",
                          class: "ss-margin-campos",
                          rules: [{ required: true }]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_empresa, {
                              varias: true,
                              empresasEspecificas: _ctx.telaBase.empresasDisponiveis,
                              codigosSelecionados: _ctx.telaBase.empresasSelecionadas,
                              "onUpdate:codigosSelecionados": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.telaBase.empresasSelecionadas) = $event))
                            }, null, 8, ["empresasEspecificas", "codigosSelecionados"])
                          ]),
                          _: 1
                        })
                      ])
                    ], 512), [
                      [_vShow, _ctx.telaBase.apresentarEmpresas]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_card, { titulo: " " }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_a_tabs, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_tab_pane, {
                          key: "0",
                          tab: "DEFINIÇÕES DO ESTOQUE"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("div", _hoisted_16, [
                                _createVNode(_component_a_form_item, {
                                  label: "Permitir tipos de produtos",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_selecionar_tipo_produto, {
                                      codigosSelecionados: _ctx.state.tiposProdutosSelecionados,
                                      "onUpdate:codigosSelecionados": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.tiposProdutosSelecionados) = $event)),
                                      varios: true
                                    }, null, 8, ["codigosSelecionados"])
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("div", _hoisted_18, [
                                _createVNode(_component_a_form_item, { class: "ss-margin-campos" }, {
                                  label: _withCtx(() => [
                                    _hoisted_19,
                                    _createVNode(_component_a_tooltip, {
                                      placement: "top",
                                      title: "Define se o sistema deve bloquear as movimentações de produtos sem quantidades disponíveis no estoque."
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_icone, {
                                          class: "ss-icone-informacao-campo",
                                          nome: "informacao-campo"
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_selecionar_sim_nao, {
                                      radioButton: true,
                                      size: "small",
                                      valor: _ctx.state.estoque.estoqueNegativo,
                                      "onUpdate:valor": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.estoque.estoqueNegativo) = $event))
                                    }, null, 8, ["valor"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_20, [
                                _createVNode(_component_a_form_item, { class: "ss-margin-campos" }, {
                                  label: _withCtx(() => [
                                    _hoisted_21,
                                    _createVNode(_component_a_tooltip, {
                                      placement: "top",
                                      title: "Define os produtos neste estoque podem ter suas quantidades ajustadas ou somente baseado em movimentações de entradas e saídas."
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_icone, {
                                          class: "ss-icone-informacao-campo",
                                          nome: "informacao-campo"
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_selecionar_sim_nao, {
                                      radioButton: true,
                                      size: "small",
                                      valor: _ctx.state.estoque.ajustarEstoque,
                                      "onUpdate:valor": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.estoque.ajustarEstoque) = $event))
                                    }, null, 8, ["valor"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_22, [
                                _createVNode(_component_a_form_item, {
                                  label: "Permitir Entradas",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_selecionar_sim_nao, {
                                      radioButton: true,
                                      size: "small",
                                      valor: _ctx.state.estoque.movimentarEntrada,
                                      "onUpdate:valor": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.estoque.movimentarEntrada) = $event))
                                    }, null, 8, ["valor"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_23, [
                                _createVNode(_component_a_form_item, {
                                  label: "Permitir Saídas",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_selecionar_sim_nao, {
                                      radioButton: true,
                                      size: "small",
                                      valor: _ctx.state.estoque.movimentarSaida,
                                      "onUpdate:valor": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.estoque.movimentarSaida) = $event))
                                    }, null, 8, ["valor"])
                                  ]),
                                  _: 1
                                })
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_tab_pane, {
                          key: "1",
                          tab: "UTILIZADORES"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, [
                                _createVNode(_component_a_form_item, {
                                  label: "Pessoa",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_selecionar_pessoa, {
                                      codigoSelecionado: _ctx.state.utilizadorCodigoPessoa,
                                      "onUpdate:codigoSelecionado": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.utilizadorCodigoPessoa) = $event)),
                                      empresas: _ctx.telaBase.empresasSelecionadas,
                                      recursoOrigem: _ctx.telaBase.identificadorRecurso
                                    }, null, 8, ["codigoSelecionado", "empresas", "recursoOrigem"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_26, [
                                _createVNode(_component_a_checkbox, {
                                  checked: _ctx.state.utilizadorEntrada,
                                  "onUpdate:checked": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.utilizadorEntrada) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Entrada")
                                  ]),
                                  _: 1
                                }, 8, ["checked"]),
                                _hoisted_27,
                                _createVNode(_component_a_checkbox, {
                                  checked: _ctx.state.utilizadorSaida,
                                  "onUpdate:checked": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.utilizadorSaida) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Saída")
                                  ]),
                                  _: 1
                                }, 8, ["checked"])
                              ]),
                              _createElementVNode("div", _hoisted_28, [
                                _createVNode(_component_a_form_item, {
                                  label: " ",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "ant-btn ant-btn-secondary ss-tamanho-completo",
                                      onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.adicionarUtilizadorEstoque()))
                                    }, " Adicionar ")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _hoisted_29,
                            (_ctx.state.estoque.utilizadores.length <= 0)
                              ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                                  key: 0,
                                  mensagem: "Adicione os utilizadores do estoque",
                                  adicionarDado: true
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_a_form, {
                              name: "ss-form-utilizadores-estoque",
                              model: _ctx.state.estoque.utilizadores
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.estoque.utilizadores, (utilizadorEstoque, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "ant-row ss-grade-personalizada-linha",
                                    key: index
                                  }, [
                                    _createElementVNode("div", _hoisted_30, [
                                      _createElementVNode("div", _hoisted_31, [
                                        _createVNode(_component_selecionar_pessoa, {
                                          codigoSelecionado: utilizadorEstoque.codigoPessoa,
                                          "onUpdate:codigoSelecionado": ($event: any) => ((utilizadorEstoque.codigoPessoa) = $event),
                                          empresas: _ctx.telaBase.empresasSelecionadas,
                                          recursoOrigem: _ctx.telaBase.identificadorRecurso,
                                          limparSelecao: false
                                        }, null, 8, ["codigoSelecionado", "onUpdate:codigoSelecionado", "empresas", "recursoOrigem"])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_32, [
                                      _createVNode(_component_a_checkbox, {
                                        checked: utilizadorEstoque.saida,
                                        "onUpdate:checked": ($event: any) => ((utilizadorEstoque.saida) = $event),
                                        class: "ss-checkbox-grande"
                                      }, null, 8, ["checked", "onUpdate:checked"])
                                    ]),
                                    _createElementVNode("div", _hoisted_33, [
                                      _createVNode(_component_a_checkbox, {
                                        checked: utilizadorEstoque.entrada,
                                        "onUpdate:checked": ($event: any) => ((utilizadorEstoque.entrada) = $event),
                                        class: "ss-checkbox-grande"
                                      }, null, 8, ["checked", "onUpdate:checked"])
                                    ]),
                                    _createElementVNode("div", _hoisted_34, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "ant-btn ant-btn-secondary",
                                        style: {"width":"100%"},
                                        onClick: ($event: any) => (_ctx.removerUtilizadorEstoque(index))
                                      }, [
                                        _createVNode(_component_icone, { nome: "excluir" })
                                      ], 8, _hoisted_35)
                                    ])
                                  ]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["model"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, (_ctx.state.estoque.tipo !== _ctx.ETipoEstoque.Sintetico)]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_requisicao_modal, {
          visivel: _ctx.modalBase.exibirRequisicaoModal,
          "onUpdate:visivel": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
          apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
          fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso,
          retornoRequisicao: _ctx.modalBase.retornoRequisicao
        }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "retornoRequisicao"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}